/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogoReadModel
 */
export interface LogoReadModel {
    /**
     * 
     * @type {string}
     * @memberof LogoReadModel
     */
    base64Image: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogoReadModel
     */
    isCustomImage: boolean;
}

/**
 * Check if a given object implements the LogoReadModel interface.
 */
export function instanceOfLogoReadModel(value: object): value is LogoReadModel {
    if (!('base64Image' in value) || value['base64Image'] === undefined) return false;
    if (!('isCustomImage' in value) || value['isCustomImage'] === undefined) return false;
    return true;
}

export function LogoReadModelFromJSON(json: any): LogoReadModel {
    return LogoReadModelFromJSONTyped(json, false);
}

export function LogoReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'base64Image': json['base64Image'],
        'isCustomImage': json['isCustomImage'],
    };
}

export function LogoReadModelToJSON(json: any): LogoReadModel {
    return LogoReadModelToJSONTyped(json, false);
}

export function LogoReadModelToJSONTyped(value?: LogoReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base64Image': value['base64Image'],
        'isCustomImage': value['isCustomImage'],
    };
}

